<span *ngIf="!isObj(text)"><pre class="text">{{text}}</pre></span>
<span *ngIf="isObj(text)"><pre class="text" *ngFor="let t of text; let l = last"><span #message 
    [innerHTML]="htmlEscapeLinking(t)" (click)="onLinkClick($event)"></span><hr *ngIf="!l"></pre></span>